import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature26',
      playScale: 0.3,
      always: false,
    },
    page: {
      className: 'home-page feature25-page',
    },
    bg: {
      className: 'feature26-bg',
      children: 'https://imm.86links.com/assets/landing/feature/feature26.png',
    },
    content: {
      className: 'feature26-content',
      title: {
        className: 'feature26-content-title',
        children: [
          {
            name: '标题0',
            className: 'feature26-content-title-item',
            children: '大标题',
          },
        ],
      },
      box: {
        className: 'feature26-content-box',
        children: [
          {
            name: '项目0',
            className: 'feature26-content-box-item',
            title: {
              className: 'feature26-content-box-item-title',
              children: [
                {
                  name: '标号',
                  className: 'feature26-content-box-item-title-num',
                  children: '01',
                },
                {
                  name: '标题',
                  className: 'feature26-content-box-item-title-text',
                  children: '请在此输入标题内容',
                },
              ],
            },
            block: {
              className: 'feature26-content-box-item-block',
              children: [
                {
                  name: '内容0',
                  className: 'feature26-content-box-item-block-text',
                  children:
                    '聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。',
                },
              ],
            },
          },
          {
            name: '项目1',
            className: 'feature26-content-box-item',
            title: {
              className: 'feature26-content-box-item-title',
              children: [
                {
                  name: '标号',
                  className: 'feature26-content-box-item-title-num',
                  children: '02',
                },
                {
                  name: '标题',
                  className: 'feature26-content-box-item-title-text',
                  children: '请在此输入标题内容',
                },
              ],
            },
            block: {
              className: 'feature26-content-box-item-block',
              children: [
                {
                  name: '内容0',
                  className: 'feature26-content-box-item-block-text',
                  children:
                    '聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。',
                },
              ],
            },
          },
        ],
      },
    },
  },
};
